export default "__VITE_ASSET__CFAWGFRL__"